// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nalYW","content":"styles_content__3_-2M","row":"styles_row__ZgdCa","footer":"styles_footer__arshk","phraseLength":"styles_phraseLength__3WFqV"};